export class ListSearchSetFieldSelectorsAction {
  constructor(public fieldSelectors: Array<string> = []) {}
}
